import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Input, Component, ChangeDetectionStrategy, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { SnFormFieldConfig } from '@lib/form';
import { TranslationService } from '@lib/translation/services';
import { SnUserFieldsGeneratorService } from '@lib/users';

export interface ISignInFormModel {
  email?: string;
  password?: string;
}

@Component({
  selector: 'sn-sign-in-form',
  templateUrl: './sign-in-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignInFormComponent implements OnInit, OnDestroy {

  @Input()
  public showingPassword: boolean;

  @Input()
  public readonly form = new UntypedFormGroup({});

  @Input()
  public formModel: ISignInFormModel = {};

  public readonly formFields$ = new BehaviorSubject<SnFormFieldConfig[]>([]);
  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _userFieldsGenerator: SnUserFieldsGeneratorService,
    private readonly _translationService: TranslationService,
  ) {}

  public ngOnInit(): void {
    this._getFormFields();
    this._translationService.events$.pipe(
      takeUntil(this._destroy$)
    ).subscribe((event) => {
      if (event.type === 'translationLoadSuccess' || event.type === 'langChanged') {
        this._getFormFields();
      }
    });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  private _getFormFields(): void {
    const fields = [
      this._userFieldsGenerator.getEmailField({
        templateOptions: {
          floatLabel: 'always',
        },
        focus: true,
      }),
      this._userFieldsGenerator.getPasswordField({
        templateOptions: {
          class: 'password-field',
          floatLabel: 'always',
        },
        hideExpression: () => !this.showingPassword,
      }),
    ];
    this.formFields$.next(fields);
  }
}
